import { Spinner } from 'react-bootstrap'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import { tieneModulo } from '../../utils/modulos'

/**
 * Componente para proteger rutas.
 *
 * Los superusuarios tienen acceso completo a todas las rutas.
 *
 * Con `modulo`, la ruta además exige que el plan del contador lo incluya. Esto **no es control de
 * acceso** --lo es el middleware del backend, que responde 403 a los datos-- pero evita que
 * escribir la URL a mano lleve a una pantalla que se queda vacía sin explicar por qué.
 */
const ProtectedRoute = ({ children, requireSuperuser = false, modulo = null }) => {
  const { isAuthenticated, isSuperuser, user } = useAuth()

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  // Si se requiere superusuario y el usuario no lo es, redirigir
  if (requireSuperuser && !isSuperuser) {
    return <Navigate to="/dashboard" replace />
  }

  // **Esperar al perfil antes de juzgar el módulo.** `isAuthenticated` es `true` en cuanto hay
  // token en `localStorage`, pero `user` llega después: lo pide `/auth/users/me/`. En esa
  // ventana `tieneModulo(null, …)` devuelve `false` y la ruta redirigía al tablero, así que
  // **recargar la página en /accounting, /reports o /nomina/auditoria sacaba al tablero** y un
  // enlace compartido a cualquiera de ellas no funcionaba. Entrar por el menú sí, porque para
  // entonces el perfil ya estaba.
  //
  // No hay riesgo de quedarse girando: si `/auth/users/me/` falla, `useAuth` llama a `logout()`
  // y la primera guarda manda a `/login`.
  if (modulo && !user) {
    return (
      <div className="d-flex justify-content-center py-5">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Cargando…</span>
        </Spinner>
      </div>
    )
  }

  // Un módulo que el plan no incluye manda al tablero, que todos tienen.
  if (modulo && !tieneModulo(user, modulo)) {
    return <Navigate to="/dashboard" replace />
  }

  return children
}

export default ProtectedRoute
